import * as React from 'react'
import { connect } from 'react-redux';
import { Program } from './Program';
import { createSession, fetchValues, removeReportPdf, requestUnchekUpdate } from '../../actions';
import { RootState } from '../../store';
import RequestList from './RequestList';
import { auth } from '../../actions/auth';
import { hashHistory } from 'react-router'
import { isEmpty } from 'lodash';
import programs from './programs_prod';
import {isUndefined} from 'util';
import ModalAlert from "../modal";

interface Props {
    createSession: (uid: string, company: Object) => any,
    fetchValues: () => any,
    removeReportPdf: (formId: string, valuesId: string, type?: 'one' | 'two') => any,
    onUnchekUpdate: (formId: any, values: any) => any,
    auth: () => any
}

class ProgramsPage extends React.Component<Props & RootState> {
    onClick = (form: string, obj: any) => this.props.createSession(form, obj);

    onRemovePdfClick = (formId: string, valuesId: string, type?: 'one' | 'two') => {
        if(confirm("Вы действительно хотите удалить PDF файл ?")){
            this.props.removeReportPdf(formId, valuesId, type)
        }
    }

    componentWillMount() {
        this.props.auth();
        this.props.fetchValues();
    }

    render() {
        const { user, settings } = this.props.forms;

        return (
            <div id="content">
                <h2>Микрогранты</h2>
                  <ul className="list-unstyled">
                    <li>
                      <a download className="btn-link" href="https://sk.ru/documents/3131/%D0%9F%D1%80%D0%B5%D0%B7%D0%B5%D0%BD%D1%82%D0%B0%D1%86%D0%B8%D1%8F_%D0%BE_%D0%BC%D0%B8%D0%BA%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BD%D1%82%D0%B0%D1%85_2025.pdf" target="__blank">Инструкция для участников</a>
                    </li>
                    <li>
                      <a download className="btn-link" href="https://sk.ru/documents/3133/%D0%9F%D1%80%D0%B8%D0%BA%D0%B0%D0%B7%D0%A0%D0%B5%D0%B3%D0%BB%D0%B0%D0%BC%D0%B5%D0%BD%D1%82.pdf" target="__blank">Общие положения</a>
                    </li>
                    <li>
                      <a download className="btn-link" href="https://sk.ru/documents/3094/%D0%90%D0%BA%D1%82%D1%83%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5_%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D1%8B_%D0%BC%D0%B8%D0%BA%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BD%D1%82%D0%BE%D0%B2.pdf" target="__blank">Актуальные программы микрогрантов</a>
                    </li>
                    <li>
                      <a download className="btn-link" href="https://sk.ru/documents/3095/%D0%A6%D0%98%D0%A1_%D0%A1%D0%BA%D0%BE%D0%BB%D0%BA%D0%BE%D0%B2%D0%BE.pdf" target="__blank">Услуги ЦИС</a>
                    </li>
                    <li>
                      <a download className="btn-link" href="https://sk.ru/documents/3166/%D0%9E%D1%82%D1%87%D0%B5%D1%82%D1%8B_%D0%9C%D0%B8%D0%BA%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BD%D1%82%D1%8B.pdf" target="__blank">Отчеты по микрогрантам</a>
                    </li>
                    <li>
                      <a download className="btn-link" href="https://disk.sk.ru/index.php/s/hzAjlOgC5ANPcBb" target="__blank">Запись вэбинара по отчетам микрогрантов</a>
                    </li>
                    {/* <li>
                      <a download className="btn-link light-red" href="/microgrant/docs/fid2_8/p131_21.pdf" target="__blank">№ 131-Пр от 14.07.2021 «О  приостановлении приема заявок на получение микрогрантов»</a>
                    </li> */}
                </ul>
                <div className="line"></div>    
                {
                    !isEmpty(user)  ?  (user.isAccess && !isUndefined(settings.statement_closed) && settings.statement_closed === true) ? [
                        //<div key={100} className="container-fluid nopad">
                        //    <div className="row">
                        //        {programs.map((prog: any, idx) =>
                        //            <Program key={idx}
                        //                title={prog.caption}
                        //                form={prog.form}
                        //                section={prog.section}
                        //                items={prog.items}
                        //                description={prog.description}
                        //                onClick={this.onClick.bind(this)}
                        //            />
                        //        )}
                        //    </div>
                        //</div>,
                        (<h4>Прием, обработка заявок по ранее действующим условиям остановлена. Уведомления об отказе в предоставлении микрогранта будут размещены в личном кабинете. Фонд осуществляет прием новых заявок через систему электронный бюджет. Детальная информация размещена по ссылкам выше.</h4>),
                        <div key={101} className="line"></div>,
                        <RequestList
                            key={102}
                            openForm={(valuesId, formId) => hashHistory.push(`/view/${formId}/${valuesId}`)}
                            removePDF={this.onRemovePdfClick}
                            onUnckedUpdate={this.props.onUnchekUpdate}
                            listUserForms={this.props.forms.listUserForms}
                        />
                    ] : !isUndefined(settings.statement_closed) && settings.statement_closed === false ? (<h4>Прием, обработка заявок по ранее действующим условиям остановлена. Уведомления об отказе в предоставлении микрогранта будут размещены в личном кабинете. Фонд осуществляет прием новых заявок через систему электронный бюджет. Детальная информация размещена по ссылкам выше.</h4>) : (<h4>У Вас недостаточно прав для создания заявки на получение микрогранта.</h4>)
                    : (<span></span>)
                }
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch: any): Props => {
    return {
        createSession: (uid: string, company: Object) => dispatch(createSession(uid, company)),
        fetchValues: () => dispatch(fetchValues()),
        auth: () => dispatch(auth()),
        onUnchekUpdate: (formId: any, valuesId: any) => dispatch(requestUnchekUpdate(formId, valuesId)),
        removeReportPdf: (formId: string, valuesId: string, type?: 'one' | 'two') => dispatch(removeReportPdf(formId, valuesId, type)),
    };
};

export default connect((state: RootState) => state, mapDispatchToProps)(ProgramsPage)



// WEBPACK FOOTER //
// ./src/components/program/index.tsx